/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { usePageData } from '../../core'
import { PAGE_PERMISSION } from '../../../../app/modules/roles/constant/role-default'

export function AsideMenuMain() {
  const intl = useIntl()
  const [isAdministrator, setIsAdministrator] = useState(false)
  const { currentUser } = usePageData()

  useEffect(() => {
    setIsAdministrator(currentUser.userRoles.includes('Administrator'))
  }, [currentUser.userRoles])

  return (
    <>
      <AsideMenuItem
          to="/dashboard"
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/home.svg"
          pagePermission={PAGE_PERMISSION.Dashboard}
        />
      <AsideMenuItem
          to="/chargers"
          title={intl.formatMessage({ id: 'MENU.CHARGERS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/plug.svg"
          pagePermission={PAGE_PERMISSION.Chargers}
        />
      <AsideMenuItem
          to="/locations"
          title={intl.formatMessage({ id: 'MENU.LOCATIONS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/marker.svg"
          pagePermission={PAGE_PERMISSION.Locations}
        />
      <AsideMenuItem
          to="/faulted-assets"
          title={intl.formatMessage({ id: 'MENU.FAULTED_ASSETS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/warning.svg"
          pagePermission={PAGE_PERMISSION.Faulted_Assets}
        />
      <AsideMenuItem
          to="/service-tickets"
          title={intl.formatMessage({ id: 'MENU.SERVICE_TICKETS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/headset.svg"
          pagePermission={PAGE_PERMISSION.Service_Tickets}
        />
      <AsideMenuItem
          to="/reports"
          title={intl.formatMessage({ id: 'MENU.REPORTS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/chart-line.svg"
          pagePermission={PAGE_PERMISSION.Reports}
        />

      <div className="menu-item">
        <div className="menu-content">
          <div className="separator mx-1 my-4"></div>
        </div>
      </div>

      <AsideMenuItemWithSub
        to="/"
        title="Administration"
        fontIcon="bi-chat-left"
        icon="/media/icons/tims/menu-administration.svg"
        pagePermissions={[
          PAGE_PERMISSION.Admin_Users,
          PAGE_PERMISSION.Admin_Groups,
          PAGE_PERMISSION.Admin_Roles,
          PAGE_PERMISSION.Admin_Settings,
          PAGE_PERMISSION.Admin_Charts,
          PAGE_PERMISSION.Admin_Audit
        ]}>
        <AsideMenuItem
          to="/user"
          title={intl.formatMessage({ id: 'MENU.USERS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-users.svg"
          pagePermission={PAGE_PERMISSION.Admin_Users}
        />

        <AsideMenuItem
          to="/groups"
          title={intl.formatMessage({ id: 'MENU.GROUPS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-groups.svg"
          pagePermission={PAGE_PERMISSION.Admin_Groups}
        />

        <AsideMenuItem
          to="/role"
          title={intl.formatMessage({ id: 'MENU.ROLES' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-roles.svg"
          pagePermission={PAGE_PERMISSION.Admin_Roles}
        />

        {/* <AsideMenuItem
          to="/settings"
          title={intl.formatMessage({ id: 'MENU.SETTINGS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/menu-settings.svg"
          pagePermission={PAGE_PERMISSION.Admin_Settings}
        />

        <AsideMenuItem
          to="/charts"
          title={intl.formatMessage({ id: 'MENU.CHARTS' })}
          fontIcon="bi-chat-left"
          icon="/media/icons/tims/list-check.svg"
          pagePermission={PAGE_PERMISSION.Admin_Charts}
        />

        <AsideMenuItem
          to='/audit'
          title={intl.formatMessage({ id: 'MENU.AUDIT' })}
          fontIcon='bi-chat-left'
          icon='/media/icons/tims/menu-audit.svg'
          pagePermission={ PAGE_PERMISSION.Admin_Audit }
        /> */}
      </AsideMenuItemWithSub>
    </>
  )
}
